import { ChangeDetectionStrategy, Component, OnInit, Signal, computed, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { Observable, map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { IFileFormFieldCropOptions } from 'lib/ui/form/fields/file-form-field.component.js';
import { CosmosDb } from 'lib/cosmos/cosmosDb.js';

@Component({
    selector: 'mod-edit-my-avatar',
    templateUrl: './edit-my-avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditMyAvatarComponent extends TypeCoreComponent<UserDb.IUserItem> implements OnInit {
	public readonly imageCrop: IFileFormFieldCropOptions = {
		aspectRatio: 'square',
		resizeToWidth: 200
	};

	public readonly form = {
		uploadedAvatar: signal<CosmosDb.ICosmosFileReference[]>([])
	};

	public readonly isValidForm: Signal<boolean> = computed(() => {
		return true;
	});

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const sharedData = this.sharedData();

		if (!sharedData) {
			return undefined;
		}

		const form = this.form;

		return this.dependencies.httpService
			.post<UserApi.IUserResponseWithToken, Partial<UserApi.IEditUserAvatarRequest>>((builder) =>
				builder
					.withCustomApiRoute('user', 'editAvatar')
					.withData({
						uploadedAvatar: form.uploadedAvatar()
					})
					.withId(sharedData.data.id)
					.build()
			)
			.pipe(
				map((response) => {
					super.updateSharedData({
						data: response.data.user,
						linkedItems: response.linkedItems
					});
					this.dependencies.authService.updateAuthUser(response.data.token);
					super.notifySaved('Profile');
				})
			);
	});

	public readonly uploadFunction: (file: File) => Observable<CosmosDb.ICosmosFileReference[]> = (file) => {
		return this.dependencies.httpService
			.uploadCustomFile<CosmosDb.ICosmosFileReference>((builder) =>
				builder.withCustomApiRoute('user', 'uploadAvatar').withFile(file).build()
			)
			.pipe(
				map((response) => {
					return [response.data];
				})
			);
	};

	constructor() {
		super();

		this.sharedDataInit = (sharedData) => {
			this.form.uploadedAvatar.set(sharedData.data.uploadedAvatar ?? []);
		};
	}

	handleUploadImage(files: CosmosDb.ICosmosFileReference[] | undefined): void {
		if (files) {
			this.form.uploadedAvatar.set(files);
			const saveHandler = this.saveHandler();

			if (saveHandler) {
				super.subscribeToObservable(saveHandler);
			}
		}
	}
}
